// extracted by mini-css-extract-plugin
module.exports = {"footerContainer":"ClientWallet_footerContainer__2pYS1","savePackageButton":"ClientWallet_savePackageButton__1V1mX"};